import {
  getTradelinkConfig,
  setTradelinkConfig,
  getTradelinkOrders,
  migrateTradelinkOrders,
  getTradelinkJobStatus,
} from "src/api";

import {
  TRADELINK_SET_CONFIG,
  TRADELINK_FAILED_CONFIG_LOAD,
  TRADELINK_SET_ORDERS,
  TRADELINK_FAILED_ORDERS_LOAD,
  TRADELINK_SET_JOB,
  TRADELINK_FAILED_JOB_LOAD,
} from "../types";

export function loadConfig() {
  return async function (dispatch, getState) {
    try {
      const config = await getTradelinkConfig();
      dispatch(setConfig(config));
    } catch (err) {
      dispatch(failedConfigLoad());
    }
  };
}

export function setConfig(config) {
  return {
    type: TRADELINK_SET_CONFIG,
    config: config,
  };
}

export function failedConfigLoad() {
  return {
    type: TRADELINK_FAILED_CONFIG_LOAD,
  };
}

export function loadOrders(limit, page, status, sortBy, startDate = "", endDate = "", search, queryParams = "") {
  return async function (dispatch, getState) {
    try {
      const orders = await getTradelinkOrders(limit, page, status, sortBy, startDate, endDate, search, queryParams);
      dispatch(setOrders(orders));
    } catch (err) {
      dispatch(failedOrdersLoad());
    }
  };
}

export function setOrders(orders) {
  return {
    type: TRADELINK_SET_ORDERS,
    orders: orders,
  };
}

export function failedOrdersLoad() {
  return {
    type: TRADELINK_FAILED_ORDERS_LOAD,
  };
}

export function loadJob() {
  return async function (dispatch, getState) {
    try {
      const job = await getTradelinkJobStatus();
      dispatch(setJob(job));
    } catch (err) {
      dispatch(failedJobLoad());
    }
  };
}

export function setJob(job) {
  return {
    type: TRADELINK_SET_JOB,
    job: job,
  };
}

export function failedJobLoad() {
  return {
    type: TRADELINK_FAILED_JOB_LOAD,
  };
}

export function saveConfig(newConfig) {
  return async function (dispatch, getState) {
    try {
      const config = await setTradelinkConfig(newConfig);
      dispatch(setConfig(config));
      return config;
    } catch (err) {
      throw err;
    }
  };
}

export function syncOrders(body) {
  return async function (dispatch, getState) {
    try {
      const result = await migrateTradelinkOrders(body);
      return result;
    } catch (err) {
      throw err;
    }
  };
} 